import { useCallback, useState } from "react";

/**
 * 표시/숨김 boolean 상태 + 토글 핸들러를 함께 제공하는 훅.
 *
 * 반환은 `[isShown, onOpen, onClose, toggle] as const` 튜플로, 구조 분해할 때 명시적 이름 부여 가능.
 *
 * @param initialValue - 초기 표시 여부 (기본 false)
 * @example
 * ```tsx
 * const [isModalOpen, openModal, closeModal] = useIsShown(false);
 * <Button onClick={openModal}>열기</Button>
 * {isModalOpen && <Modal onClose={closeModal} />}
 * ```
 */
export const useIsShown = (initialValue?: boolean) => {
  const [isShown, setIsShown] = useState(initialValue ?? false);

  const onOpen = useCallback(() => {
    setIsShown(true);
  }, []);

  const onClose = useCallback(() => {
    setIsShown(false);
  }, []);

  const toggle = useCallback(() => setIsShown((prev) => !prev), [setIsShown]);
  return [isShown, onOpen, onClose, toggle] as const;
};
